module.exports = __webpack_public_path__ + "images/generic-business-logo@1x-e1a9ab9cb8b26686362a90cde6ab46eb.png";